export const Logo = ({ light = false }) => (
  <a href="#home" data-testid="logo-link" className="flex items-center gap-3 group">
    <span className="flex items-center justify-center w-11 h-11 rounded-full bg-white shadow-[0_2px_12px_rgba(0,26,77,0.15)] overflow-hidden transition-transform duration-300 group-hover:scale-105">
      <img src="/logo-mark.png" alt="FivePoint Physiotherapy logo" className="w-9 h-9 object-contain" />
    </span>
    <span className="leading-none">
      <span className={`block font-display font-extrabold text-lg tracking-tight ${light ? "text-white" : "text-ink"}`}>
        FivePoint
      </span>
      <span className={`block text-[10px] tracking-[0.35em] uppercase ${light ? "text-white/70" : "text-neutral-500"}`}>
        Physiotherapy
      </span>
    </span>
  </a>
);
